export default __webpack_public_path__ + "static/media/veg.d2c21d2a.svg";